<div class="row">
  <div class="col-sm-12">
    <section class="panel">
      <app-page-title title="Create Case" [loading]="isLoading"></app-page-title>

      <div class="panel-body">
        <form class="form-horizontal" (ngSubmit)="create()" ngNativeValidate>
          <app-case-form [case]="case" *ngIf="case"></app-case-form>
        </form>
      </div>
    </section>
  </div>
</div>


